import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import navdata from "./LayoutMenuData";

const SidebarContent = (props) => {
    const navData = navdata().props.children;
    const pathName = process.env.PUBLIC_URL + props.location.pathname;

    const renderItem = (item, key) => {
        if (item.isHeader) {
            return (
                <li key={key} style={{ listStyle: "none", padding: "0.85rem 0.85rem 0.4rem" }}>
                    <span style={{
                        display: "inline-block",
                        fontFamily: "var(--bl-font-body)",
                        fontSize: "0.7rem",
                        fontWeight: 600,
                        color: "var(--bl-text-soft)",
                        textTransform: "uppercase",
                        letterSpacing: "0.08em",
                    }}>
                        {item.label}
                    </span>
                </li>
            );
        }

        const target = item.link ? process.env.PUBLIC_URL + item.link : "";
        const isActive = target === pathName;

        return (
            <li key={key} className="nav-item" style={{ listStyle: "none" }}>
                <Link
                    to={item.link || "/#"}
                    onClick={item.click}
                    className={`nav-link${isActive ? " active" : ""}`}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        padding: "0.55rem 0.85rem",
                        margin: "2px 8px",
                        borderRadius: "0.65rem",
                        fontSize: "0.9rem",
                        textDecoration: "none",
                        transition: "background 160ms ease, color 160ms ease",
                        color: isActive ? "#fff" : "var(--bl-text-muted)",
                        background: isActive ? "rgba(var(--bl-accent-rgb), 0.18)" : "transparent",
                        boxShadow: isActive ? "inset 2px 0 0 var(--bl-accent)" : "none",
                    }}
                >
                    {item.icon && (
                        <i
                            className={item.icon}
                            style={{
                                fontSize: "1rem",
                                color: isActive ? "var(--bl-accent-light)" : "var(--bl-text-soft)",
                                flexShrink: 0,
                            }}
                        />
                    )}
                    <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {item.label}
                    </span>
                </Link>
            </li>
        );
    };

    return (
        <React.Fragment>
            {(navData || []).map((item, key) => renderItem(item, key))}
        </React.Fragment>
    );
};

export default withRouter(SidebarContent);
